import { useBrandLoaderData } from "../../../../root/rootLoader";
import { useHomeContextUser } from "../../../homeContext";

export default function useHasAccountCenterResources() {
  const brand = useBrandLoaderData();
  const user = useHomeContextUser();

  return (
    brand.Resources.enabled && (user.hasAncillaries || user.hasAccessCodes)
  );
}
